export const DISMISSED_AUTOMATIC_FULL_ACTIONS_NOTICE_PREFERENCE =
  'LLM_DISMISSED_AUTOMATIC_FULL_ACTIONS_NOTICE';
